<span class="page-header__icon basket-qty__icon"
      cy-basketBagBtn
      [attr.aria-label]="'Basket quantity %' | translate : basket.qty"
      [attr.qty-bullet]="basket.qty || undefined">
    <i [ngClass]="icon()"
       aria-hidden="true"></i>
</span>